import { resolveHostAuthConfiguration } from './hostAuthConfig';

const tenantHost = requireConfiguration('VITE_TENANT_NAME', import.meta.env.VITE_TENANT_NAME);

const { clientId } = resolveHostAuthConfiguration(window.location.hostname);

const apiScope = `api://${clientId}/api.read`; 

if (!/^[a-z0-9-]+\.ciamlogin\.com$/i.test(tenantHost)) {
  throw new Error('VITE_TENANT_NAME must be a Microsoft Entra External ID ciamlogin.com host.');
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://${tenantHost}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: import.meta.env.VITE_CACHE_LOCATION || 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access', apiScope],
};

export const apiTokenRequest = {
  scopes: [apiScope],
};

function requireConfiguration(name: string, value: string | undefined): string {
  const configuredValue = value?.trim();
  if (!configuredValue) {
    throw new Error(`${name} is required.`);
  }

  return configuredValue;
}
